// Path: src\Components\MyContest\MyContestList.jsx
import React, { useEffect, useState } from 'react';
import BaseHome from "../Home/BaseHome"
import MyTournamentList from "./MyTournamentTab";
import MyContestListTab from "./MyContestTab";
import PrivateScrimList from './PrivateScrimTab';
import { useNavigate } from "react-router";
import { t } from 'i18next';
import TabWithBottomBorder from '../Common/TabWithBottomBorderNewStyle';

const MyContestList = () => {
  const [activeTab, setActiveTab] = useState('contests');
  const navigate = useNavigate();

  // Content for each tab
  const getTabContent = () => {
    console.log("activeTab", activeTab)
    switch (activeTab) {
      case 'contests':
        return <div className="mytab-content" style={{ textTransform: "lowercase"}}><MyContestListTab /></div>;
      case 'tournaments':
        return <div className="mytab-content" style={{ textTransform: "lowercase"}}> <MyTournamentList /></div>;
      case 'private':
        return <div className="mytab-content" style={{ textTransform: "lowercase"}}> <PrivateScrimList /></div>;
      default:
        return null;
    }
  };
  const getTabContent2 = () => {
    // switch (tabs) {
    //   case 0:
    //     return <div className="mytab-content"></div>;
    //   case 1:
    //     return <div className="mytab-content"></div>;

    //   default:
    //     return null;
    // }
  };
  const [value, setValue] = useState(0);
   const [activeTab1, setActiveTab1] = useState(0)
    useEffect(()=>{
      if(activeTab1){
        setActiveTab(activeTab1===0? 'contests':activeTab1===1?'tournaments':'private')
      }
      else {
        setActiveTab('contests')
      }
    },[activeTab1])
  return (
    <BaseHome isRemoveScroll={true} title={localStorage?.getItem('activeGame') ? localStorage?.getItem('activeGame')?.toLowerCase() + " matches" : "pubg matches"} 
    onBackClick={() =>{
      navigate(`/game-type/${localStorage.getItem("activeGameId")}`);
       }} >


<div className="commontabs testimonial-tabs autosize-tab">
<div className="commontabs-innerwrap tab-backgrounnd-new-style">
        <TabWithBottomBorder getTabContent={getTabContent2}  tabs={[t("my_Contest.contest"),t("my_Contest.tournament"),t("my_Contest.private")]}
         activeTab={activeTab1} setActiveTab={setActiveTab1} 
         setValue={setValue} />
        </div>
      </div>
      <div className="mytab-content-container mytab-content-container-new">{getTabContent()}</div>
    </BaseHome>
  );
};

export default MyContestList;
